export default __webpack_public_path__ + "static/media/ResetPassword.1f30d9de.txt";